import { useAuthRecoveryState } from '@/composables/useAuthRecoveryState';
import AuthCallbackContent from './AuthCallbackContent.vue';
export default {
  __name: 'AuthRecoveryDialog',
  setup(__props) {
    const {
      visible,
      busy,
      retry,
      reload
    } = useAuthRecoveryState();
    return {
      __sfc: true,
      visible,
      busy,
      retry,
      reload,
      AuthCallbackContent
    };
  }
};